/*
ROMIX CART DRAWER PREMIUM v1.4
- Precio comparativo original en naranja.
- Precio final en verde.
- Descuento normal y descuento extra separados.
- Compatibilidad con packs Romix.
*/

(function () {
  var drawer;
  var overlay;
  var itemsContainer;
  var emptyBox;
  var subtotalBox;
  var totalBox;
  var normalSavingRow;
  var normalSavingBox;
  var extraSavingRow;
  var extraSavingBox;
  var totalSavingRow;
  var totalSavingBox;
  var discountInput;
  var discountMessage;
  var checkoutButton;
  var statusText;
  var toast;
  var toastText;
  var activeDiscountCode = '';
  var toastTimer;
  var productCache = {};

  function money(cents) {
    var safeCents = Number(cents || 0);

    try {
      return (safeCents / 100).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      return (safeCents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initCartDrawer() {
    drawer = document.getElementById('RomixCartDrawer');
    overlay = document.getElementById('RomixCartOverlay');
    toast = document.getElementById('RomixCartToast');

    if (!drawer || drawer.dataset.ready === 'true') return;

    drawer.dataset.ready = 'true';

    itemsContainer = drawer.querySelector('[data-rcd-items]');
    emptyBox = drawer.querySelector('[data-rcd-empty]');
    subtotalBox = drawer.querySelector('[data-rcd-subtotal]');
    totalBox = drawer.querySelector('[data-rcd-total]');
    normalSavingRow = drawer.querySelector('[data-rcd-normal-saving-row]');
    normalSavingBox = drawer.querySelector('[data-rcd-normal-saving]');
    extraSavingRow = drawer.querySelector('[data-rcd-extra-saving-row]');
    extraSavingBox = drawer.querySelector('[data-rcd-extra-saving]');
    totalSavingRow = drawer.querySelector('[data-rcd-total-saving-row]');
    totalSavingBox = drawer.querySelector('[data-rcd-total-saving]');
    discountInput = drawer.querySelector('[data-rcd-discount-input]');
    discountMessage = drawer.querySelector('[data-rcd-discount-message]');
    checkoutButton = drawer.querySelector('[data-rcd-checkout]');
    statusText = drawer.querySelector('[data-rcd-status]');
    toastText = toast ? toast.querySelector('[data-rcd-toast-text]') : null;

    document.querySelectorAll('[data-rcd-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (checkoutButton) checkoutButton.addEventListener('click', goToCheckout);

    var applyButton = drawer.querySelector('[data-rcd-apply-discount]');
    if (applyButton) applyButton.addEventListener('click', applyDiscount);

    drawer.addEventListener('click', function (event) {
      var qtyButton = event.target.closest('[data-rcd-change]');
      var removeButton = event.target.closest('[data-rcd-remove]');

      if (qtyButton) {
        changeQuantity(
          qtyButton.dataset.key,
          parseInt(qtyButton.dataset.qty, 10)
        );
      }

      if (removeButton) {
        changeQuantity(removeButton.dataset.key, 0);
      }
    });

    interceptAddToCartForms();
    interceptCartLinks();
    refreshCart(false);
  }

  function openDrawer() {
    if (!drawer || !overlay) return;

    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('rcd-open');
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rcd-open');

    setTimeout(function () {
      overlay.hidden = true;
    }, 280);
  }

  function refreshCart(openAfter) {
    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('No se pudo cargar el carrito.');
        }

        return response.json();
      })
      .then(function (cart) {
        return loadComparePrices(cart.items).then(function (comparePrices) {
          renderCart(cart, comparePrices);
          updateCartBubble(cart.item_count);

          if (openAfter) {
            openDrawer();
          }

          return cart;
        });
      })
      .catch(function (error) {
        console.error('Romix cart refresh error:', error);
      });
  }

  function loadComparePrices(items) {
    var requests = [];
    var handles = {};

    (items || []).forEach(function (item) {
      if (item.handle && !handles[item.handle]) {
        handles[item.handle] = true;
        requests.push(loadProduct(item.handle));
      }
    });

    return Promise.all(requests).then(function () {
      var result = {};

      (items || []).forEach(function (item) {
        var product = productCache[item.handle];
        var comparePrice = 0;

        if (product && product.variants) {
          var variant = product.variants.find(function (candidate) {
            return Number(candidate.id) === Number(item.variant_id);
          });

          if (variant) {
            comparePrice = Number(variant.compare_at_price || 0);
          }
        }

        result[item.key] = comparePrice;
      });

      return result;
    });
  }
    function loadProduct(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }

    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'No se pudo cargar el producto ' + handle
          );
        }

        return response.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      })
      .catch(function (error) {
        console.warn(
          'Romix compare price error:',
          error
        );

        productCache[handle] = {
          variants: []
        };

        return productCache[handle];
      });
  }

  function renderCart(cart, comparePrices) {
    if (!itemsContainer) {
      return;
    }

    itemsContainer.innerHTML = '';

    if (!cart.items.length) {
      if (emptyBox) {
        emptyBox.hidden = false;
      }

      if (subtotalBox) {
        subtotalBox.textContent = money(0);
      }

      if (totalBox) {
        totalBox.textContent = money(0);
      }

      hideSavingRows();

      if (checkoutButton) {
        checkoutButton.disabled = true;
      }

      if (statusText) {
        statusText.textContent =
          'Compra segura y envío gratuito';
      }

      return;
    }

    if (emptyBox) {
      emptyBox.hidden = true;
    }

    if (checkoutButton) {
      checkoutButton.disabled = false;
    }

    if (statusText) {
      statusText.textContent =
        '✓ Producto añadido correctamente';
    }

    var catalogOriginalTotal = 0;
    var normalSavingTotal = 0;
    var extraSavingTotal = 0;

    cart.items.forEach(function (item) {
      var image = item.image || '';
      var optionsHtml = buildOptionsHtml(item);

      var compareUnitPrice = Number(
        comparePrices[item.key] || 0
      );

      var currentUnitPrice = Number(
        item.original_price ||
        item.price ||
        0
      );

      var finalUnitPrice = Number(
        item.final_price ||
        currentUnitPrice
      );

      var compareLinePrice =
        compareUnitPrice *
        item.quantity;

      var currentLinePrice = Number(
        item.original_line_price ||
        currentUnitPrice *
        item.quantity
      );

      var finalLinePrice = Number(
        item.final_line_price ||
        finalUnitPrice *
        item.quantity
      );

      var hasNormalDiscount =
        compareUnitPrice > 0 &&
        compareUnitPrice >
          currentUnitPrice;

      var hasExtraDiscount =
        finalLinePrice <
        currentLinePrice;

      var normalSaving =
        hasNormalDiscount
          ? Math.max(
              0,
              compareLinePrice -
                currentLinePrice
            )
          : 0;

      var extraSaving =
        hasExtraDiscount
          ? Math.max(
              0,
              currentLinePrice -
                finalLinePrice
            )
          : 0;

      catalogOriginalTotal +=
        hasNormalDiscount
          ? compareLinePrice
          : currentLinePrice;

      normalSavingTotal +=
        normalSaving;

      extraSavingTotal +=
        extraSaving;

      var priceHtml =
        buildItemPriceHtml({
          compareLinePrice:
            compareLinePrice,
          currentLinePrice:
            currentLinePrice,
          finalLinePrice:
            finalLinePrice,
          normalSaving:
            normalSaving,
          extraSaving:
            extraSaving,
          hasNormalDiscount:
            hasNormalDiscount,
          hasExtraDiscount:
            hasExtraDiscount,
          quantity:
            item.quantity
        });

      var itemHtml =
        '<div class="rcd-item">' +
          '<img src="' +
            escapeAttribute(image) +
            '" alt="' +
            escapeAttribute(
              item.product_title
            ) +
          '">' +
          '<div>' +
            '<p class="rcd-item-title">' +
              escapeHtml(
                item.product_title
              ) +
            '</p>' +
            '<div class="rcd-item-options">' +
              optionsHtml +
            '</div>' +
            priceHtml +
            '<div>' +
              '<div class="rcd-qty">' +
                '<button type="button" data-rcd-change data-key="' +
                  escapeAttribute(
                    item.key
                  ) +
                  '" data-qty="' +
                  Math.max(
                    0,
                    item.quantity - 1
                  ) +
                '">−</button>' +
                '<span>' +
                  item.quantity +
                '</span>' +
                '<button type="button" data-rcd-change data-key="' +
                  escapeAttribute(
                    item.key
                  ) +
                  '" data-qty="' +
                  (
                    item.quantity + 1
                  ) +
                '">+</button>' +
              '</div>' +
              '<button type="button" class="rcd-remove" data-rcd-remove data-key="' +
                escapeAttribute(
                  item.key
                ) +
              '">Eliminar</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      itemsContainer.insertAdjacentHTML(
        'beforeend',
        itemHtml
      );
    });

    if (subtotalBox) {
      subtotalBox.textContent =
        money(
          catalogOriginalTotal
        );
    }

    if (totalBox) {
      totalBox.textContent =
        money(
          cart.total_price
        );
    }

    updateSavingRow(
      normalSavingRow,
      normalSavingBox,
      normalSavingTotal
    );

    updateSavingRow(
      extraSavingRow,
      extraSavingBox,
      extraSavingTotal
    );

    var totalSaving =
      normalSavingTotal +
      extraSavingTotal;

    if (
      totalSavingRow &&
      totalSavingBox
    ) {
      if (totalSaving > 0) {
        totalSavingRow.hidden =
          false;

        totalSavingBox.textContent =
          money(totalSaving);
      } else {
        totalSavingRow.hidden =
          true;

        totalSavingBox.textContent =
          '';
      }
    }
  }

  function buildOptionsHtml(item) {
    if (
      !item.options_with_values ||
      !item.options_with_values.length
    ) {
      return '';
    }

    return item.options_with_values
      .filter(function (option) {
        return (
          option.value &&
          option.value !==
            'Default Title'
        );
      })
      .map(function (option) {
        return (
          '<div><strong>' +
          escapeHtml(option.name) +
          ':</strong> ' +
          escapeHtml(option.value) +
          '</div>'
        );
      })
      .join('');
  }
    function buildItemPriceHtml(data) {
    var html =
      '<div class="rcd-item-price">';

    if (data.hasNormalDiscount) {
      html +=
        '<span class="rcd-item-price-compare">' +
        money(data.compareLinePrice) +
        '</span>';
    }

    if (data.hasExtraDiscount) {
      html +=
        '<span class="rcd-item-price-before-extra">' +
        money(data.currentLinePrice) +
        '</span>';
    }

    html +=
      '<strong class="rcd-item-price-current">' +
      money(data.finalLinePrice) +
      '</strong>';

    if (data.hasExtraDiscount) {
      html +=
        '<span class="rcd-item-price-label">' +
        'Precio final con promoción para ' +
        data.quantity +
        (
          data.quantity === 1
            ? ' unidad'
            : ' unidades'
        ) +
        '</span>';
    }

    if (data.normalSaving > 0) {
      html +=
        '<span class="rcd-item-saving">' +
        'Ahorras ' +
        money(data.normalSaving) +
        ' por la rebaja del producto' +
        '</span>';
    }

    if (data.extraSaving > 0) {
      html +=
        '<span class="rcd-item-saving">' +
        'Ahorras ' +
        money(data.extraSaving) +
        ' extra por la promoción' +
        '</span>';
    }

    html += '</div>';

    return html;
  }

  function updateSavingRow(
    row,
    box,
    amount
  ) {
    if (!row || !box) {
      return;
    }

    if (amount > 0) {
      row.hidden = false;
      box.textContent =
        '−' + money(amount);
    } else {
      row.hidden = true;
      box.textContent = '';
    }
  }

  function hideSavingRows() {
    if (normalSavingRow) {
      normalSavingRow.hidden =
        true;
    }

    if (extraSavingRow) {
      extraSavingRow.hidden =
        true;
    }

    if (totalSavingRow) {
      totalSavingRow.hidden =
        true;
    }

    if (normalSavingBox) {
      normalSavingBox.textContent =
        '';
    }

    if (extraSavingBox) {
      extraSavingBox.textContent =
        '';
    }

    if (totalSavingBox) {
      totalSavingBox.textContent =
        '';
    }
  }

  function changeQuantity(
    key,
    quantity
  ) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json',
        Accept:
          'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'No se pudo actualizar el carrito.'
          );
        }

        return response.json();
      })
      .then(function () {
        return refreshCart(false);
      })
      .catch(function (error) {
        console.error(
          'Romix quantity error:',
          error
        );

        alert(
          'No se pudo actualizar el carrito.'
        );
      });
  }

  function applyDiscount() {
    var code =
      discountInput
        ? discountInput.value.trim()
        : '';

    if (!discountMessage) {
      return;
    }

    discountMessage.classList.remove(
      'is-ok',
      'is-error'
    );

    if (!code) {
      activeDiscountCode = '';

      discountMessage.textContent =
        'Introduce un código de descuento.';

      discountMessage.classList.add(
        'is-error'
      );

      return;
    }

    activeDiscountCode =
      code.toUpperCase();

    discountMessage.textContent =
      'Código preparado. Se aplicará en la pantalla de pago si es válido.';

    discountMessage.classList.add(
      'is-ok'
    );
  }

  function goToCheckout() {
    var code =
      activeDiscountCode ||
      (
        discountInput
          ? discountInput.value.trim()
          : ''
      );

    if (code) {
      window.location.href =
        '/discount/' +
        encodeURIComponent(code) +
        '?redirect=/checkout';
    } else {
      window.location.href =
        '/checkout';
    }
  }

  function getRomixProductJson(
    romixRoot
  ) {
    var productJsonScript =
      romixRoot.querySelector(
        'script[type="application/json"][data-rpp-product-json]'
      ) ||
      document.querySelector(
        'script[type="application/json"][data-rpp-product-json]'
      );

    if (!productJsonScript) {
      return null;
    }

    try {
      return JSON.parse(
        productJsonScript.textContent
      );
    } catch (error) {
      console.error(
        'Romix product JSON error:',
        error
      );

      return null;
    }
  }

  function findVariantId(
    productJson,
    options
  ) {
    if (
      !productJson ||
      !productJson.variants
    ) {
      return null;
    }

    var matchedVariant =
      productJson.variants.find(
        function (variant) {
          return options.every(
            function (
              optionValue,
              index
            ) {
              return (
                String(
                  variant.options[
                    index
                  ]
                )
                  .trim()
                  .toLowerCase() ===
                String(optionValue)
                  .trim()
                  .toLowerCase()
              );
            }
          );
        }
      );

    return matchedVariant
      ? matchedVariant.id
      : null;
  }
    function buildRomixAddPayload(
    form
  ) {
    var romixRoot =
      form.closest(
        '.romix-product-pro'
      );

    var quantityInput =
      form.querySelector(
        '[name="quantity"]'
      );

    var fallbackVariantInput =
      form.querySelector(
        '[name="id"]'
      );

    var fallbackVariantId =
      fallbackVariantInput
        ? fallbackVariantInput.value
        : null;

    var fallbackQuantity =
      quantityInput
        ? parseInt(
            quantityInput.value,
            10
          ) || 1
        : 1;

    if (!romixRoot) {
      return {
        items: [
          {
            id:
              fallbackVariantId,
            quantity:
              fallbackQuantity
          }
        ]
      };
    }

    var productJson =
      getRomixProductJson(
        romixRoot
      );

    var openBundle =
      romixRoot.querySelector(
        '[data-rpp-bundle-option].is-open'
      ) ||
      romixRoot.querySelector(
        '.rpp-bundle-option.is-open'
      );

    var bundleUnits =
      openBundle
        ? openBundle.querySelectorAll(
            '[data-rpp-bundle-unit]'
          )
        : [];

    if (
      bundleUnits.length > 1
    ) {
      var bundleItems = [];

      bundleUnits.forEach(
        function (unit) {
          var options = [];

          unit
            .querySelectorAll(
              '[data-rpp-pack-option]'
            )
            .forEach(
              function (select) {
                options.push(
                  select.value
                );
              }
            );

          var variantId =
            findVariantId(
              productJson,
              options
            );

          if (variantId) {
            bundleItems.push({
              id: variantId,
              quantity: 1
            });
          }
        }
      );

      if (bundleItems.length) {
        return {
          items: bundleItems
        };
      }
    }

    var selectedOptions = [];

    romixRoot
      .querySelectorAll(
        '.rpp-option'
      )
      .forEach(
        function (fieldset) {
          var checked =
            fieldset.querySelector(
              'input:checked'
            );

          if (checked) {
            selectedOptions.push(
              checked.value
            );
          }
        }
      );

    var selectedVariantId =
      findVariantId(
        productJson,
        selectedOptions
      );

    return {
      items: [
        {
          id:
            selectedVariantId ||
            fallbackVariantId,
          quantity:
            fallbackQuantity
        }
      ]
    };
  }

  function interceptAddToCartForms() {
    if (
      window
        .romixCartFormsIntercepted
    ) {
      return;
    }

    window
      .romixCartFormsIntercepted =
      true;

    document.addEventListener(
      'submit',
      function (event) {
        var form =
          event.target;

        if (
          !form.matches(
            'form[action*="/cart/add"]'
          )
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var button =
          form.querySelector(
            '[type="submit"]'
          );

        var originalText =
          button
            ? button.textContent
            : '';

        if (button) {
          button.disabled =
            true;

          button.dataset.originalText =
            originalText;

          button.textContent =
            'AÑADIDO ✓';

          button.classList.add(
            'rcd-added-button'
          );
        }

        var payload =
          buildRomixAddPayload(
            form
          );

        fetch(
          '/cart/add.js',
          {
            method: 'POST',
            body:
              JSON.stringify(
                payload
              ),
            headers: {
              'Content-Type':
                'application/json',
              'X-Requested-With':
                'XMLHttpRequest',
              Accept:
                'application/json'
            }
          }
        )
          .then(
            function (
              response
            ) {
              if (
                !response.ok
              ) {
                throw new Error(
                  'No se pudo añadir el producto.'
                );
              }

              return response.json();
            }
          )
          .then(function () {
            showToast(
              'Tu producto se ha añadido correctamente.'
            );

            return refreshCart(
              true
            );
          })
          .catch(
            function (
              error
            ) {
              console.error(
                'Romix add error:',
                error
              );

              alert(
                'No se pudo añadir el producto. Inténtalo de nuevo.'
              );
            }
          )
          .finally(
            function () {
              if (button) {
                setTimeout(
                  function () {
                    button.disabled =
                      false;

                    button.textContent =
                      button.dataset
                        .originalText ||
                      originalText;

                    button.classList.remove(
                      'rcd-added-button'
                    );
                  },
                  1200
                );
              }
            }
          );
      },
      true
    );
  }
    function interceptCartLinks() {
    document.addEventListener(
      'click',
      function (event) {
        var link =
          event.target.closest(
            'a[href="/cart"], a[href*="/cart"]'
          );

        if (!link) {
          return;
        }

        if (
          link.href &&
          link.href.indexOf(
            '/cart'
          ) === -1
        ) {
          return;
        }

        event.preventDefault();

        refreshCart(true);
      }
    );
  }

  function updateCartBubble(
    count
  ) {
    document
      .querySelectorAll(
        '.cart-count-bubble'
      )
      .forEach(
        function (bubble) {
          bubble.innerHTML =
            '<span aria-hidden="true">' +
            count +
            '</span>';

          bubble.style.display =
            count > 0
              ? ''
              : 'none';
        }
      );
  }

  function showToast(
    message
  ) {
    if (!toast) {
      return;
    }

    if (toastText) {
      toastText.textContent =
        message;
    }

    toast.hidden = false;

    window.requestAnimationFrame(
      function () {
        toast.classList.add(
          'is-visible'
        );
      }
    );

    clearTimeout(
      toastTimer
    );

    toastTimer =
      setTimeout(
        function () {
          toast.classList.remove(
            'is-visible'
          );

          setTimeout(
            function () {
              toast.hidden =
                true;
            },
            260
          );
        },
        3600
      );
  }

  function escapeHtml(
    text
  ) {
    return String(
      text || ''
    )
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );
  }

  function escapeAttribute(
    text
  ) {
    return escapeHtml(
      text
    );
  }
    document.addEventListener(
    'DOMContentLoaded',
    initCartDrawer
  );

  document.addEventListener(
    'shopify:section:load',
    initCartDrawer
  );
})();